import { setLang } from '../../services/lang';

export const changeLanguage = (lang) => {
    setLang(lang);
    return lang;
};